import { getCurrentUserEmail } from '../auth';
import { getEightDInfoId } from '../eightDInfoStore';

const toIsoOrNull = (date) => {
  if (!date) return null;
  try {
    const d = date instanceof Date ? date : new Date(date);
    return isNaN(d.getTime()) ? null : d.toISOString();
  } catch {
    return null;
  }
};

export const buildD7Payload = ({
  eightDInfoId,
  holisticView = '',
  responsiblePerson = '',
  plannedDate = null,
  achievedDate = null,
  actionRows = [],
  uploadedFiles = [],
  isDisabled = false,
  attachmentsToRemove = [],
  actionToRemove = [],
  currentUserEmail = getCurrentUserEmail(),
  d7Id = null,
}) => {
  const nowIso = new Date().toISOString();
  const finalEightDInfoId = eightDInfoId || getEightDInfoId();

  const Action = (actionRows || []).map((row) => ({
    ...(row.id ? { D7ActionId: Number(row.id) } : {}),
    EightDInfoId: finalEightDInfoId,
    Action: row.action || '',
    Responsible: row.responsible || '',
    TargetDate: toIsoOrNull(row.date),
    Status: row.status || '',
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
  }));

  const Attachments = (uploadedFiles || [])
    .filter(f => !f.isExisting)
    .map((f) => {
      const base64Data = f.preview || '';
      const attachmentData = base64Data.startsWith('data:') ? base64Data : base64Data ? `data:${f.file?.type || 'image/jpeg'};base64,${base64Data}` : '';
      return {
        EightDInfoId: finalEightDInfoId,
        AttachmentName: f.file?.name || '',
        AttachmentType: f.file?.type || '',
        AttachmentData: attachmentData,
        CreatedBy: currentUserEmail,
        CreatedOn: nowIso,
      };
    });

  return {
    ...(d7Id ? { D7Id: d7Id } : {}),
    EightDInfoId: finalEightDInfoId,
    HolisticView: holisticView || '',
    ResponsiblePerson: responsiblePerson || '',
    PlannedDate: toIsoOrNull(plannedDate),
    AchievedDate: toIsoOrNull(achievedDate),
    CreatedBy: currentUserEmail,
    CreatedOn: nowIso,
    ModifiedBy: currentUserEmail,
    ModifiedOn: nowIso,
    IsDisabled: isDisabled,
    Action,
    Attachments,
    ActionToRemove: actionToRemove || [],
    AttachmentsToRemove: attachmentsToRemove || [],
  };
};
